import { useSnackbar } from 'notistack'
import { t } from '@lingui/macro'

import { useLazyGetDmpConnectBuildDownloadQuery } from '@/core/services/dmp-connect'
import { getApiErrorMessage } from '@/utils/errors'

export function useDmpConnectDownloadBuild() {
  const { enqueueSnackbar } = useSnackbar()
  const [downloadBuild, { isFetching, originalArgs }] = useLazyGetDmpConnectBuildDownloadQuery()

  const download = async (os: 'windows' | 'macos') => {
    try {
      await downloadBuild(os).unwrap()
      enqueueSnackbar(t`DMP Connect build downloaded successfully`, { variant: 'success' })
    } catch (error) {
      enqueueSnackbar(getApiErrorMessage(error, t`An error occurred while downloading the DMP Connect build`), { variant: 'error' })
    }
  }

  const isDownloadingMacOSBuild = isFetching && originalArgs === 'macos'
  const isDownloadingWindowsBuild = isFetching && originalArgs === 'windows'

  return { download, isDownloadingMacOSBuild, isDownloadingWindowsBuild }
}
